import { createRoot } from "react-dom/client";
import "../index.css";
import { PropertyPalContainer } from "./pp-container";

// Create container and render - no whitelist logic here (server handles it)
const container = document.createElement("div");
container.id = "property-pal-root";
document.body.appendChild(container);

const root = createRoot(container);
root.render(<PropertyPalContainer />);
